export default "__VITE_ASSET__Bpq1WBG5__"